// extracted by mini-css-extract-plugin
export var container = "styles-module--container--NT2+q";
export var blockContainer = "styles-module--blockContainer--a-EYb";
export var screenContainer = "styles-module--screenContainer--cu7JH";
export var screenTitle = "styles-module--screen-title--U3eaH";
export var screenContent = "styles-module--screen-content--GdEvy";
export var imageWrapper = "styles-module--imageWrapper--8tplt";
export var image = "styles-module--image--WlXwL";